import React, { useState, useEffect } from "react"
import Details from "./Details"
import "./styles.css"
import { db } from "../../firebaseFunctions/authhook";
import { RiDeleteBinLine } from "react-icons/ri"

import {
    collection,
    getDocs,
    DocumentData,
    doc,
    updateDoc,
    where,
    onSnapshot,
    query,
    orderBy,
    deleteDoc,
} from "firebase/firestore";
import { ClipLoader } from "react-spinners";
import TimeFormat from "./TimeFormat";


const Dashboard: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [showInput, setShowInput] = useState(false);
    const [seat, setSeat] = useState<Number | any>(0);
    const [seatData, setSeatData] = useState<Object | any>({
        id: '',
        totalNumberOfSeat: '',
    })
    const [timesData, setTimesData] = useState<Object | any>({
        id: '',
        openingTime: '',
        closingTime: ''
    });
    const [openingTime, setOpeningTime] = useState('');
    const [closingTime, setClosingTime] = useState('');

    const [appointmentList, setAppointmentList] = useState<DocumentData[] | []>([]);
    const usersCollectionRef = collection(db, "appointment_lists");
    const seatCollectionRef = collection(db, "seatAvailablePerDay");
    const timeSchedulingRef = collection(db, "timeScheduling");

    const handleSeat = async () => {
        const { id } = seatData;
        const userDoc = doc(db, "seatAvailablePerDay", id);
        const newFields = { totalNumberOfSeat: seat };
        await updateDoc(userDoc, newFields);
        setSeatData((curr: any) => ({ ...curr, totalNumberOfSeat: `${seat}` }))
        setShowInput(false)
    };


    useEffect(() => {
        setLoading(true)
        const getUsers = async () => {
            const seat = await getDocs(seatCollectionRef);
            const seatdat = seat.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
            setSeatData(seatdat[0])

            const t = query(timeSchedulingRef);
            onSnapshot(t, (snapshot) => {
                const times = snapshot.docs.map((doc: any) => ({ ...doc.data(), id: doc.id }));
                setTimesData(times[0]);
                setOpeningTime(times[0].openingTime)
                setClosingTime(times[0].closingTime)
            })
            setLoading(false)
        };
        getUsers();
    }, []);

    const [searchString, setSearchString] = useState('')
    useEffect(() => {
        if (searchString.length > 0) {
            const q = query(usersCollectionRef, where('mobileNumber', ">=", searchString));
            onSnapshot(q, (snapshot) => {
                const list = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
                setAppointmentList(list)
            })
        }
        else {
            const q = query(usersCollectionRef, where('date', "==", new Date().toDateString()), orderBy('createdAt', 'desc'));
            onSnapshot(q, (snapshot) => {
                const list = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
                setAppointmentList(list)
            })
        }
    }, [searchString])

    useEffect(() => {
        const deleteAutomatically = async () => {
            const q = query(usersCollectionRef, where('date', "!=", new Date().toDateString()));
            onSnapshot(q, (snapshot) => {
                snapshot.docs.map(async (docs) => {
                    await deleteDoc(doc(db, "appointment_lists", docs.id));
                });
            })
        };
        deleteAutomatically();
    }, []);
    const handleCollectionDelete = async () => {
        const data = await getDocs(usersCollectionRef);
        data.docs.map(async (docs) => {
            await deleteDoc(doc(db, "appointment_lists", docs.id));
        });
    }

    const [showOpenTime, setShowOpenTime] = useState(false);
    const handleTimeSchedulingOpen = async () => {
        const { id } = timesData;
        const timeDoc = doc(db, "timeScheduling", id);
        const newFields = { openingTime: openingTime };
        await updateDoc(timeDoc, newFields)
            .then((res) => console.log(res))
            .catch((err) => console.log(err));
        setTimesData((curr: any) => ({ ...curr, openingTime: openingTime }))
        setShowOpenTime(false)
    }


    const [showClosingTime, setShowClosingTime] = useState(false);
    const handleTimeSchedulingClose = async () => {
        const { id } = timesData;
        const timeDoc = doc(db, "timeScheduling", id);
        const newFields = { closingTime: `${closingTime}` }

        await updateDoc(timeDoc, newFields);
        setTimesData((curr: any) => ({ ...curr, closingTime: `${closingTime}` }))
        setShowClosingTime(false)
    }

    return (
        <div className="admin-pages flex-col-hstart-vstart" style={{ height: appointmentList.length > 3 ? 'auto' : "100vh" }}>
            <div className="admin">
                <p dir="rtl" className="txt-375">لوحة التحكم</p>
                <input
                    className="inputDesign"
                    name="search"
                    type="text"
                    placeholder="ابحث عن رقم الجوال"
                    onChange={(e) => setSearchString(e.target.value)}
                />
                <p dir="rtl" className="txt-602">ابحث عن العميل عن طريق رقم الجوال</p>

                <div className="timeScheduling">
                    <div dir="rtl" className="openingTime">
                        <p>فتح: &nbsp;
                            {
                                loading ?
                                    <ClipLoader loading={true} size={20} />
                                    :
                                    showOpenTime ?
                                        <>
                                            <input type="time" name="" id="" value={openingTime} onChange={(e) => setOpeningTime(e.target.value)} />
                                            <button onClick={handleTimeSchedulingOpen}>save</button>
                                        </>
                                        :
                                        <span onClick={() => setShowOpenTime(true)}>
                                            <TimeFormat time={timesData.openingTime} />
                                        </span>
                            }
                        </p>

                    </div>
                    <div dir="rtl" className="closingTime">
                        <p>أغلاق: &nbsp;
                            {
                                loading ?
                                    <ClipLoader loading={true} size={20} />
                                    :
                                    showClosingTime ?
                                        <>
                                            <input type="time" name="" id="" value={closingTime} onChange={(e) => setClosingTime(e.target.value)} />
                                            <button onClick={() => handleTimeSchedulingClose()}>save</button>
                                        </>
                                        :
                                        <span onClick={() => setShowClosingTime(true)}>
                                            <TimeFormat time={timesData.closingTime} />
                                        </span>
                            }

                        </p>
                    </div>
                </div>

                <div className="deleteCollection">
                    <RiDeleteBinLine onClick={() => handleCollectionDelete()} />
                    <p onClick={() => handleCollectionDelete()}>حذف قاعدة البيانات يدويًا</p>
                </div>
                <div className="group-275 flex-row">
                    <p className="txt-481">عدد الارقام المتاحة</p>
                    {
                        showInput ?
                            <>
                                <input type="number" className="inputDesignAdmin" onChange={(e) => setSeat(e.target.value)} />
                                <button className="buttonadmin" onClick={handleSeat}>save</button>
                            </>
                            :
                            <div className="text-field-1 flex-row-vcenter-hcenter" onClick={() => setShowInput(true)}>
                                <div className="txt-853 flex-hcenter">{
                                    loading ?
                                        <div style={{ textAlign: 'center' }}>
                                            <ClipLoader color={'green'} loading={true} size={20} />
                                        </div>
                                        :
                                        seatData.totalNumberOfSeat
                                }</div>
                            </div>
                    }
                </div>
                <p dir="rtl" className="txt-386">العملاء</p>
                <p dir="rtl" className="txt-124">العملاء الذين حجزوا في هذا اليوم</p>

                {
                    loading ?
                        <div style={{ textAlign: 'center' }}>
                            <ClipLoader color={'green'} loading={true} size={40} />
                        </div>
                        :
                        appointmentList.map((data, index) => {
                            if (data.indexNumber > 0 && data.indexNumber <= seatData.totalNumberOfSeat) {
                                return <Details {...data} key={index} />
                            }
                        })
                }
            </div>
        </div>
    )
}

export default Dashboard;
